import { Directive, ElementRef, Input, OnChanges, OnInit, OnDestroy, Renderer2, inject } from '@angular/core';
import { FsessionService } from 'src/app/servicios/session/fsession.service';
import { Subscription } from 'rxjs';

export enum ValidRoles {
  ADMINISTRADOR = 1,
  ESTANDAR = 2,
  DEMO = 3,
  SUPERVISOR = 4,
  ROL_DE_PRUEBAS = 5,
  CLIMA = 6,
  ADMINISTRADOR_MUNICIPIO = 7,
  MULTIMUNICIPIO = 8,
  SUPER_ADMINISTRADOR = 9,
  ADMINISTRADOR_MUNICIPIO_DGT = 41,
  COLLADO_VILLALBA = 38
}

@Directive({
  selector: '[appValidateRoles]',
  standalone: false
})
export class ValidateRolesDirective implements OnInit, OnChanges, OnDestroy {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private _fsessionService = inject(FsessionService);


  @Input() idRoles: ValidRoles[] = [];
  @Input() excludedRoles: ValidRoles[] = [];
  @Input() ocultar: ValidRoles[] = [];

  private roleSub: Subscription | null = null;
  private lastRole: number | null = null;
  private originalInlineStyle: string | null = null;

  ngOnInit(): void {
    try {
      this.originalInlineStyle = this.el.nativeElement.getAttribute('style');
    } catch {
      this.originalInlineStyle = null;
    }

    this.roleSub = this._fsessionService.getRole$().subscribe((role) => {
      const n = Number(role);
      if (!Number.isFinite(n) || Number.isNaN(n)) {
        this.lastRole = null;
        this.hideElement();
      } else {
        this.lastRole = n;
        this.evaluateVisibility(n);
      }
    });
  }

  ngOnChanges(): void {
    if (this.lastRole !== null) {
      this.evaluateVisibility(this.lastRole);
    }
  }

  ngOnDestroy(): void {
    if (this.roleSub) {
      this.roleSub.unsubscribe();
      this.roleSub = null;
    }
  }

  /**
   * Evaluar la visibilidad del elemento
   * @param idRolUser - El rol del usuario
   * @returns 
   */
  private evaluateVisibility(idRolUser: number) {
    if (this.ocultar && this.ocultar.length > 0) {
      const visible = this.ocultar.includes(idRolUser);
      visible ? this.showElement() : this.hideElement();
      return;
    }

    if (this.idRoles && this.idRoles.length > 0) {
      this.idRoles.includes(idRolUser) ? this.showElement() : this.hideElement();
      return;
    }

    if (this.excludedRoles && this.excludedRoles.length > 0) {
      this.excludedRoles.includes(idRolUser) ? this.hideElement() : this.showElement();
      return;
    }

    this.showElement();
  }

  /**
   * Oculta el elemento
   */
  private hideElement() {
    if (!this.el?.nativeElement) { return; }

    const hideStyle = 'display:none !important; visibility:hidden !important; pointer-events:none !important;';
    this.renderer.setAttribute(this.el.nativeElement, 'style', hideStyle);
    this.renderer.setAttribute(this.el.nativeElement, 'aria-hidden', 'true');
    this.renderer.setAttribute(this.el.nativeElement, 'hidden', 'true');
  }

  /**
   * Muestra el elemento
   * @returns
   */
  private showElement() {
    if (!this.el?.nativeElement) { return; }

    if (this.originalInlineStyle && this.originalInlineStyle.length > 0) {
      this.renderer.setAttribute(this.el.nativeElement, 'style', this.originalInlineStyle);
    } else {
      this.renderer.removeAttribute(this.el.nativeElement, 'style');
    }

    try { this.renderer.removeAttribute(this.el.nativeElement, 'aria-hidden'); } catch {}
    try { this.renderer.removeAttribute(this.el.nativeElement, 'hidden'); } catch {}
  }
}
